import { gql } from '@apollo/client';

export const DASHBOARD_BENEFICIARIES = gql`
  query DashboardBeneficiaries($input: FilterArgs) {
    totalBeneficiariesInApprovedSessions(input: $input) {
      month
      count
    }
  }
`;
